import { ServerElement } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */
class Server extends ServerElement {
  /**
   * OpenAPI 3.2: Name to identify this server.
   */
  get name() {
    return this.get('name');
  }
  set name(name) {
    this.set('name', name);
  }
}
export default Server;